export const formattedDate = (time) => {
  const date = new Date(time);
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  return `${month < 10 ? '0' : ''}${month}/${day}/${year}`;
};
